/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import PropTypes from "prop-types";
import "./attachment.module.css";
import { CustomLink } from "../../../components/custom-link";
import { ATTACHMENT_TYPE } from "../../../constants";

var loaderPromise = null;
var Document = null;
var Page = null;
var pdfjs = null;

function loadLibrary() {
  console.log("calling load");

  if (loaderPromise === null) {
    loaderPromise = import(
      /* webpackChunkName: "qtc-react-pdf" */
      "react-pdf"
    )
      .then(response => {
        Document = response.Document;
        Page = response.Page;
        pdfjs = response.pdfjs;
      })
      .catch(err => {
        console.log("Failed to load react-pdf", err);
        return Promise.reject();
      });
  }
  return loaderPromise;
}
function isLibraryLoaded() {
  return Document !== null;
}
export class Attachment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNumber: 1
    };
  }

  componentDidMount() {
    this._isMounted = true;
    loadLibrary().then(() => this._isMounted && this.forceUpdate());
  }

  componentWillUnmount() {
    this._isMounted = false;
  }
  getPreview(template, contentType, url) {
    const { pageNumber } = this.state;
    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
    return template === "attachment-element-1" && contentType === ATTACHMENT_TYPE.PDF ? (
      <div styleName="attachment-preview">
        <Document file={url}>
          <Page pageNumber={pageNumber} />
        </Document>
      </div>
    ) : null;
  }

  render() {
    const { "file-name": fileName, url, "content-type": contentType } = this.props.element;
    const buttonValue = contentType === ATTACHMENT_TYPE.PDF ? "Preview" : "Download";
    return (
      <div styleName="content-wrapper">
        {isLibraryLoaded() ? this.getPreview(this.props.template, contentType, url) : null}
        <div styleName={this.props.template}>
          <div styleName="attachment-title" dangerouslySetInnerHTML={{ __html: fileName }} />
          <CustomLink styleName="attachment-link" href={url} target="_blank" rel="noopener noreferrer" download>
            {`${buttonValue}`}
          </CustomLink>
        </div>
      </div>
    );
  }
}

Attachment.propTypes = {
  element: PropTypes.shape({
    url: PropTypes.string,
    fileName: PropTypes.string,
    contentType: PropTypes.string
  }),
  template: PropTypes.string
};
